import React, { useContext, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { TaxiBookingContext } from "./BookTaxiContext";

export default function BlurHandler(props){

    const {
        formikProps,
        bookingHook='',
        slideIndex=0
    } = props;

    const cardRef = useRef(null);

    const taxiBookingContext = useContext(TaxiBookingContext);
    
    const {
        focusKey='',
        focusIndex
    } = taxiBookingContext;

    
    const isFocused = ((bookingHook === focusKey) && (slideIndex === focusIndex));

    const handleClickOutside = (event) => {
        
        // Check if the click target is not within the card and does not have a specific class name
        if(isFocused){
            if (
                cardRef.current &&
                !cardRef.current.contains(event.target)
            ) {
                
                if(!event.target.classList.contains('MuiAutocomplete-option')){
                    if(!event.target.classList.contains('MuiListItem-root')){
                        if(!event.target.classList.contains('MuiCalendarPicker-root')){
                            if(event.target.localName !== 'body'){
                                formikProps.handleSubmit();
                            }
                        }
                    }
                }
                else{
                    console.log(event.target);
                }   
    
            }
        }
    };

    useEffect(() => {
        if(isFocused){
            setTimeout(()=>{
                document.addEventListener('click', handleClickOutside);
            },50);
            // Add click event listener to the document
            
        }

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isFocused]);


    return (
        <Box ref={cardRef}>
            {props.children}
        </Box>
    );

}